import React from "react";
import { Img } from "../../shared/img";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * Componente que retorna los logos de los software recomendados
 * @returns {JSX.Element} Recommended
 */
export const Recommended = () => {
    return (
        <div className="d-flex mx-3">
            <div className="mr-3">
                <Icon icon="logos:firefox" alt="Logo del navegador mozilla firefox" width={24}className="d-block mx-auto"/>
                <p className="sr-only text-center text-14 onsecondary--color">Firefox</p>
            </div>
            <div className="mr-3">
                <Icon icon="devicon:chrome" alt="Logo del navegador chrome" width={24}className="d-block mx-auto"/>
                <p className="sr-only text-center text-14 onsecondary--color">Chrome</p>
            </div>
            <div className="mr-3">
                <Icon icon="devicon:safari" alt="Logo del navegador chrome" width={24}className="d-block mx-auto"/>
                <p className="sr-only text-center text-14 onsecondary--color">Safari</p>
            </div>
            <div style={{ height: 24 }} className="mr-3">
                <Img src="/img/nvda.png" alt="Logo del software nvda" width={24} className="d-block mx-auto"/>
                <p className="sr-only text-center text-14 onsecondary--color">NVDA</p>
            </div>
        </div>
    )
}